import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MaterialIcon from '@/components/ui/MaterialIcon';
import AppShell from '@/components/layout/AppShell';
import providerService from '@/services/providerService';

const ProviderSearchPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [city, setCity] = useState('');

  const providerTypes = providerService.getProviderTypes();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (searchQuery) params.append('name', searchQuery);
    if (selectedType) params.append('type', selectedType);
    if (city) params.append('city', city);
    
    navigate(`/providers/list?${params.toString()}`);
  };

  return (
    <AppShell title="Trouver un prestataire" showBack backLabel="Accueil" onBack={() => navigate('/dashboard')}>
      <div className="flex flex-col gap-6 p-4 md:p-0 md:pt-4 md:max-w-2xl">
        <form onSubmit={handleSearch} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Recherche</label>
            <div className="relative">
              <input
                type="text"
                placeholder="Nom, établissement..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full rounded-xl border border-gray-200 bg-white p-3 pl-10 text-sm outline-none focus:border-primary dark:border-white/10 dark:bg-surface-dark dark:text-white"
              />
              <MaterialIcon icon="search" className="absolute left-3 top-3 text-gray-400" />
            </div>
          </div>

          <div className="flex flex-col gap-2">
             <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Spécialité / Type</label>
             <div className="relative">
                <select
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                  className="w-full appearance-none rounded-xl border border-gray-200 bg-white p-3 pl-10 text-sm outline-none focus:border-primary dark:border-white/10 dark:bg-surface-dark dark:text-white"
                >
                  <option value="">Tous les types</option>
                  {providerTypes.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
                <MaterialIcon icon="local_hospital" className="absolute left-3 top-3 text-gray-400" />
                <MaterialIcon icon="expand_more" className="absolute right-3 top-3 text-gray-400" />
             </div>
          </div>

           <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Ville ou Quartier</label>
            <div className="relative">
              <input
                type="text"
                placeholder="Dakar, Mermoz..."
                value={city}
                onChange={(e) => setCity(e.target.value)}
                className="w-full rounded-xl border border-gray-200 bg-white p-3 pl-10 text-sm outline-none focus:border-primary dark:border-white/10 dark:bg-surface-dark dark:text-white"
              />
              <MaterialIcon icon="location_on" className="absolute left-3 top-3 text-gray-400" />
            </div>
          </div>

          <button
            type="submit"
            className="mt-4 flex w-full items-center justify-center rounded-xl bg-primary py-3 font-bold text-[#102216] transition-opacity hover:opacity-90"
          >
            Rechercher
          </button>
        </form>

        {/* Quick Categories */}
        <div>
           <h2 className="mb-3 text-lg font-bold text-[#111813] dark:text-white">Catégories</h2>
           <div className="grid grid-cols-4 gap-3">
             {[
               { icon: 'medical_services', label: 'Généraliste', type: 'doctor' },
               { icon: 'dentistry', label: 'Dentiste', type: 'dentist' },
               { icon: 'medication', label: 'Pharmacie', type: 'pharmacy' },
               { icon: 'visibility', label: 'Opticien', type: 'optician' },
             ].map((cat) => (
               <button
                 key={cat.type}
                 onClick={() => {
                   setSelectedType(cat.type);
                   navigate(`/providers/list?type=${cat.type}`);
                 }}
                 className="flex flex-col items-center gap-2"
               >
                 <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary-dark dark:text-primary hover:bg-primary/20 transition-colors">
                   <MaterialIcon icon={cat.icon} />
                 </div>
                 <span className="text-xs font-medium text-gray-600 dark:text-gray-400">{cat.label}</span>
               </button>
             ))}
           </div>
        </div>
      </div>
    </AppShell>
  );
};

export default ProviderSearchPage;
